import { LanghoutBetonApp } from './LanghoutBetonApp.js';

customElements.define('langhout-beton-app', LanghoutBetonApp);
